export default "__VITE_ASSET__QCdA29M0__"